import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { MAP_INCIDENT_TYPE_TO_URL_PREFIX } from '../constants'

import { saveCommentAndTagsError, saveCommentAndTagsSuccess } from './actions'
import { COMMENT_AND_TAGS_UPDATE_ASYNC } from './constants'

const updateCommentAndTagsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(COMMENT_AND_TAGS_UPDATE_ASYNC.INITIATE)
    .mergeMap((action) =>
      api.resolutionCenter
        .saveCommentAndTags(
          action.payload.reportId,
          {
            comment: action.payload.comment,
            isCommunity: action.payload.isSharedComment,
            tags: action.payload.tags,
            classifiedAs: action.payload.reportState,
            communityUser: action.payload.communityUser,
          },
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[action.payload.reportType],
          store.getState().partnerOptions.selectedCompany?.value
        )
        .map((response) =>
          saveCommentAndTagsSuccess(
            response,
            action.payload.reportId,
            action.payload.reportType,
            action.payload.reportState
          )
        )
        .takeUntil(action$.ofType(COMMENT_AND_TAGS_UPDATE_ASYNC.CANCEL))
    )
    .catch((error) => Observable.of(epicsErrorHandler(saveCommentAndTagsError, error)))

export default combineEpics(updateCommentAndTagsEpic)
